import { render, staticRenderFns } from "./OurHouses.vue?vue&type=template&id=07ea68b4&scoped=true&"
import script from "./OurHouses.vue?vue&type=script&lang=js&"
export * from "./OurHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ea68b4",
  null
  
)

export default component.exports